<template>
  <div v-loading="loading">
    <div style="width: 1190px; margin: auto;">
      <div class="topMenu" style='margin-top: 10px;'>
        <top-menu 
        :flows="flows"
        :curFlowTit="curFlowTit"
        :cates="cates"
        :common="common"
        :all="all"
        :cateId="typeId"
        :curFlowIndex="curFlowIndex"
        :keywords="keywords"
        :timeRange="timeRange"
        @selectFlow="selectFlow"
        @selectCate="selectCate"
        @search="search"
        ></top-menu>
<!--         <div class='fixedMenu' v-if='curFlowTit == "addFlow"'>
          <top-menu 
          :flows="flows"
          :curFlowTit="curFlowTit"
          :cates="cates"
          :common="common"
          :cateId="cateId"
          :curFlowIndex="curFlowIndex"
          :keywords="keywords"
          :timeRange="timeRange"
          @selectFlow="selectFlow"
          @selectCate="selectCate"
          @search="search"
          ></top-menu>
        </div> -->
      </div>
      
      <el-col :span="24" class="m-t-20">
        <transition name="fade" mode="out-in" appear>
          <router-view></router-view>
        </transition>
       <!--  <add-flow v-if='curFlowTit == "addFlow"' name="addFlow" :cateId="cateId" :keywords="keywords" :searchNum="searchNum" @setCurCate="setCurCate" @setKeywords="setKeywords"></add-flow>
        <my-flow v-if='curFlowTit == "myFlow"' :cateId="cateId" :keywords="keywords" :searchNum="searchNum" :timeRange="timeRange" @setKeywords="setKeywords"></my-flow>
        <follow v-if='curFlowTit == "follow"' :cateId="cateId" :keywords="keywords" :searchNum="searchNum" :timeRange="timeRange" @setKeywords="setKeywords"></follow>
        <mystart v-if='curFlowTit == "mystart"' :cateId="cateId" :keywords="keywords" :searchNum="searchNum" :timeRange="timeRange" @setKeywords="setKeywords"></mystart>
        <datam v-if='curFlowTit == "data"' :cateId="cateId" :keywords="keywords" :searchNum="searchNum" :timeRange="timeRange" @setKeywords="setKeywords"></datam> -->
      </el-col>
    </div>
  </div>
</template>
<style scoped>
  .fixedMenu{
    position: fixed;
    top: 0px;
    z-index: 99;
    top: 70px;
    overflow: hidden;
    border: 1px solid #f1f2f7;
    background: #f1f2f7;
    /*opacity: 0;*/
    transition: all 0.3s;
    -moz-transition: all 0.3s; /* Firefox 4 */
    -webkit-transition: all 0.3s; /* Safari 和 Chrome */
    -o-transition: all 0.3s; /* Opera */
  }
</style>
<script>
  import http from '../../../assets/js/http'
  import daterangeFilter from '../../Common/business/filter/daterangeFilter'
  // import addFlow from './addFlow'
  // import myFlow from './myFlow'
  // import mystart from './mystart'
  // import follow from './follow'
  // import datam from './data'
  import topMenu from './topMenu'
  export default {
    name: 'flow',
    data() {
      return {
        loading: false,
        cates: [],
        flows: [
          { title: 'addFlow', name: '发起流程' , selected: true },
          { title: 'follow', name: '已办事项' , selected: false },
          { title: 'myFlow', name: '我的待办' , selected: false },
          { title: 'mystart', name: '我的发起' , selected: false },
          { title: 'data', name: '数据管理' , selected: false }
        ],
        curFlowTit: '',
        typeId: -1,
        common: false,
        all: true,
        keywords: '',
        // curKeywords: '',
        searchNum: 0,
        timeRange: [],
        // startTime: '',
        // endTime: '',
        curFlowIndex: 0
        // searchShow: false
      }
    },
    methods: {
      setKeywords(keywords) {
        this.keywords = keywords
      },
      search(val) {
        if (this.curFlowTit == 'addFlow') {
          router.push({ name: this.curFlowTit, query: { keywords: val.keywords }})
        } else {
          let startTime = ''
          let endTime = ''
          if (val.timeRange.length == 2) {
            startTime = val.timeRange[0]
            endTime = val.timeRange[1]
          }
          let query = {
            typeId: this.typeId,
            keywords: val.keywords,
            startTime: startTime,
            endTime: endTime
          }
          router.push({ name: this.curFlowTit, query: query })
        }
      },
      selectCate(cate) {
        console.log(cate)
        if (this.curFlowTit == 'addFlow') {
          this.typeId = cate.typeId // 二级类别
          this.changeActive()
          let tabTitle = document.getElementsByClassName('tabTitle')
          if (tabTitle.length > 0) {
            if (cate.typeId >= 0) {
              _(tabTitle).forEach((tab) => {
                tab.style.display = 'none'
              })
              tabTitle[cate.index].style.display = 'block'
            } else {
              _(tabTitle).forEach((tab) => {
                tab.style.display = 'block'
              })
            }
          }
        } else {
          let startTime = ''
          let endTime = ''
          if (this.timeRange.length == 2) {
            startTime = this.timeRange[0]
            endTime = this.timeRange[1]
          }
          let query = {
            typeId: cate.typeId,
            keywords: this.keywords,
            startTime: startTime,
            endTime: endTime
          }
          router.push({ name: this.curFlowTit, query: query })
        }
      },
      getFlowCates() {
        this.apiGet('bpm/types/side').then((res) => {
          if (res.code == 200) {
            _(res.data).forEach((res) => {
              res.selected = false
            })
            this.cates = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      selectFlow(index) {
        router.push({ name: this.flows[index]['title'], query: { typeId: 0 }})
      },
      changeActive() {
        _(this.flows).forEach((val, index) => {
          if (val.title == this.curFlowTit) {
            this.curFlowIndex = index
            val.selected = true
          } else {
            val.selected = false
          }
        })
        if (this.typeId == 0) {
          this.common = true
        } else {
          this.common = false
        }
        if (this.typeId == -1) {
          this.all = true
        } else {
          this.all = false
        }
      }
    },
    created() {
      this.getFlowCates()
      this.curFlowTit = this.$route.name
      this.changeActive()
      let tabTitle = document.getElementsByClassName('tabTitle')
      console.log(tabTitle)
      if (tabTitle.length > 0) {
        _(tabTitle).forEach((tab) => {
          tab.style.display = 'block'
        })
      }
    },
    mounted() {
    },
    watch: {
      '$route' (to, from) {
        this.curFlowTit = to.name
        if (to.query.typeId) {
          this.typeId = parseInt(to.query.typeId)
        } else {
          this.typeId = 0
        }
        if (to.query.keywords) {
          this.keywords = to.query.keywords
        } else {
          this.keywords = ''
        }
        console.log(this.keywords)
        if (to.query.startTime && to.query.endTime) {
          this.timeRange = [to.query.startTime, to.query.endTime]
        } else {
          this.timeRange = []
        }
        this.changeActive()
      }
    },
    computed: {
    },
    components: {
      daterangeFilter,
      topMenu
    },
    mixins: [http]
  }

</script>


// WEBPACK FOOTER //
// flow.vue?65c93009